import * as THREE from 'three'
import React from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
    nodes: {
        head: THREE.Mesh
    }
    materials: {}
}

const UserHead = function(
    props: JSX.IntrinsicElements['mesh'],
    ref: React.Ref<THREE.Mesh<THREE.BufferGeometry<THREE.NormalBufferAttributes>, THREE.Material | THREE.Material[]>> | undefined
) {
    const { nodes, materials } = useGLTF('objects/head.gltf') as GLTFResult
    return (
        <group dispose={null}>
            <mesh
                {...props}
                ref={ref}
                geometry={nodes.head.geometry}
                material={nodes.head.material}
            />
        </group>
    )
}

export default React.forwardRef(UserHead)

useGLTF.preload('objects/head.gltf')